import React, { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute";
import Layout from "../components/Layout";
import ITaxQuest from "../pages/ITaxQuest";
const ITaxQuestA = lazy(() => import("../pages/ITaxQuestA"));

// Lazy-loaded pages
const Welcome = lazy(() => import("../pages/Welcome"));
const Login = lazy(() => import("../pages/Login"));
const ApproverLogin = lazy(() => import("../pages/ApproverLogin"));
const Register = lazy(() => import("../pages/Register"));
const Preparer = lazy(() => import("../pages/Preparer"));
const Approver = lazy(() => import("../pages/Approver"));
const Feedback = lazy(() => import("../pages/Feedback"));
const FeedbackA = lazy(() => import("../pages/FeedbackA"));
const ECIForm = lazy(() => import("../pages/ECI/ECIForm"));
const FormC = lazy(() => import("../pages/FormC/FormC"));
const ClientList = lazy(() => import("../pages/Clients/ClientList"));
const ClientCreateEdit = lazy(() => import("../pages/Clients/ClientCreateEdit"));
const EngagementList = lazy(() => import("../pages/Engagements/EngagementList"));
const EngagementCreateEdit = lazy(() => import("../pages/Engagements/EngagementCreateEdit"));
const NotFound = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/welcome",
    element: <Welcome />,
  },

  {
    path: "/login",
    element: <Login />,
  },

  {
    path: "/approver-login",
    element: <ApproverLogin />,
  },

  {
    path: "/register",
    element: <Register />,
  },

  {
    path: "/preparer",
    element: (
      <ProtectedRoute>
        <Preparer />
      </ProtectedRoute>
    ),
  },

  {
    path: "/feedback",
    element: <Feedback />,
  },
  {
    path: "/feedback-approver",
    element: (
      <ProtectedRoute>
        <FeedbackA />
      </ProtectedRoute>
    ),
  },

  {
    path: "/approver",
    element: (
      <ProtectedRoute>
        <Approver />
      </ProtectedRoute>
    ),
  },

  {
    path: "/itaxquest",
    element: (
      <ProtectedRoute>
        <ITaxQuest />
      </ProtectedRoute>
    ),
  },
  {
    path: "/itaxquest-approver",
    element: (
      <ProtectedRoute>
        <ITaxQuestA />
      </ProtectedRoute>
    ),
  },

  {
    path: "/eci",
    element: (
      <ProtectedRoute>
        <ECIForm />
      </ProtectedRoute>
    ),
  },
  {
    path: "/formc",
    element: (
      <ProtectedRoute>
        <FormC />
      </ProtectedRoute>
    ),
  },
  // clients: wrapped with ProtectedRoute and Layout. children render inside Layout via <Outlet />
  {
    path: "/clients",
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      // index route -> /clients
      { index: true, element: <ClientList /> },
      { path: "create", element: <ClientCreateEdit /> },
      { path: ":id/edit", element: <ClientCreateEdit /> },
    ],
  },

  // engagements: same pattern
  {
    path: "/engagements",
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <EngagementList /> },
      { path: "create", element: <EngagementCreateEdit /> },
      { path: ":id/edit", element: <EngagementCreateEdit /> },
    ],
  },

  // fallback route
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;